.fieldGrid {
  display: flex;
  gap: 1rem;
  align-items: end;
  width: 75%;
}
.selectItem {
  width: 100%;
}

.selectWrapper {
  width: calc((100% - 2rem) / 3);
  flex-shrink: 0;
  flex-grow: 0;
}
